import React, { Component } from "react";
import {
  ImgCreacionEmpresa,
  ImgCreacionEmpresa2,
} from "../../images/servicios";
import { ModernServicePage } from "../modern";

export class Empresa extends Component {
  render() {
    const serviceData = {
      title: "Creación de Empresa",
      subtitle:
        "No des este paso tan importante en tu emprendimiento sin una asesoría adecuada",
      description:
        "Te acompañamos en cada paso del proceso de formalización de tu empresa para asegurar el éxito de tu emprendimiento.",
      whatsappMessage: "Hola, necesito información sobre creación de empresa",
      features: [
        {
          emoji: "🏢",
          title: "Formaliza tu Empresa",
          description:
            "Es importante constituir tu empresa, porque te permitirá separar el patrimonio de tu negocio del personal. Separarás tus finanzas de las de la empresa y gozarás de una limitación de responsabilidad hasta el límite de tu aporte.",
        },
        {
          emoji: "🤝",
          title: "Asociarte con Otras Personas",
          description:
            "Una empresa te permite asociarte con otras personas. En esta asociación se establecen cuestiones tan importantes, como por ejemplo de qué forma van a participar cada uno en las utilidades y pérdidas de la empresa.",
        },
        {
          emoji: "💰",
          title: "Captar Inversión",
          description:
            "La mayoría de las veces, las empresas para comenzar a funcionar requieren de grandes sumas de dinero antes de comenzar a producir. Una empresa constituida formalmente facilita el acceso a inversores.",
        },
        {
          emoji: "🎯",
          title: "Seriedad a tu Negocio",
          description:
            "Tus clientes y proveedores mirarán con buenos ojos estar realizando negocios con una empresa y no con una persona natural, ya que normalmente las empresas tienen estructuras complejas y distintos colaboradores trabajando en ellas.",
        },
        {
          emoji: "🏦",
          title: "Productos Bancarios",
          description:
            "Con tu empresa podrás ir obteniendo distintos productos bancarios como cuentas a la vista, cuentas corriente empresas, créditos, capitales de trabajo, todo según el comportamiento crediticio y movimientos de la empresa.",
        },
        {
          emoji: "🎁",
          title: "Fondos Concursables",
          description:
            "El estado tiene una serie de programas pensados y orientados a la formalización de empresas, toda vez que estas generan nuevas fuentes de trabajo y nuevas fuentes de recaudación de impuestos.",
        },
      ],
      images: [
        {
          src: ImgCreacionEmpresa,
          alt: "Creación de Empresa Profesional",
        },
        {
          src: ImgCreacionEmpresa2,
          alt: "Constitución Empresarial",
        },
      ],
      benefits: [
        "Proceso 100% legal y transparente",
        "Asesoría completa desde el inicio",
        "Tramitación rápida y eficiente",
        "Todos los documentos incluidos",
        "Orientación sobre tipo de empresa",
        "Soporte post-constitución",
        "Precios competitivos del mercado",
      ],
      navigationItems: [
        { id: "feature-0", label: "Formalización" },
        { id: "feature-1", label: "Sociedades" },
        { id: "feature-2", label: "Inversión" },
        { id: "feature-3", label: "Beneficios" },
      ],
    };

    return <ModernServicePage {...serviceData} />;
  }
}

export default Empresa;
